<template>
    <ul class="flex items-center flex-col gap-[20px] md:w-[49%] xl:w-[100%]">
        <!-- <li
            @click="handlecategoriesList"
            class="flex items-center font-semibold text-[18px] text-[#242D21] border-background last:border-none w-full"
            :class="{
                'flex-row-reverse gap-6 justify-end': isOpenCategories,
                'justify-between flex-row': !isOpenCategories,
            }"
        >
            {{ $t("common.categories") }}

            <icon-arrow
                class="text-[15px] text-primary"
                :class="{
                    'rotate-[90deg]': !isOpenCategories,
                    'rotate-[270deg]': isOpenCategories,
                }"
            />
        </li>
        <li
            v-show="isOpenCategories"
            class="w-full text-[18px] border-background last:border-none pl-[8px]"
        >
            <MenuCategoryList
                @close-mobile-menu="$emit('close-menu')"
                class="md:w-[372px]"
            />
        </li> -->
        <template v-if="!isOpenCategories">
            <li class="font-semibold text-[18px] text-[#242D21] w-full items-center border-background last:border-none hover:text-primary">
                <router-link
                    @click="$emit('close-mobile-menu')"
                    :to="{ name: '/for-schools' }"
                    class="font-semibold text-[18px] text-[#242D21]"
                >
                    {{ $t("for-schools-page.title") }}
                </router-link>
            </li>
            <li class="font-semibold text-[18px] text-[#242D21] w-full items-center border-background last:border-none hover:text-primary">
                <router-link
                    @click="$emit('close-mobile-menu')"
                    :to="{ name: '/for-families' }"
                    class="font-semibold text-[18px] text-[#242D21]"
                >
                    {{ $t("for-families-page.title") }}
                </router-link>
            </li>
            <li class="font-semibold text-[18px] text-[#242D21] w-full items-center border-background last:border-none hover:text-primary">
                <router-link
                    @click="$emit('close-mobile-menu')"
                    :to="{ name: '/for-providers' }"
                    class="font-semibold text-[18px] text-[#242D21]"
                >
                    {{ $t("for-providers-page.title") }}
                </router-link>
            </li>
            <li class="font-semibold text-[18px] text-[#242D21] w-full items-center border-background last:border-none hover:text-primary">
                <router-link
                    @click="$emit('close-mobile-menu')"
                    :to="{ name: '/programs' }"
                    class="font-semibold text-[18px] text-[#242D21]"
                >
                    {{ $t("common.programs") }}
                </router-link>
            </li>
            <li class="font-semibold text-[18px] text-[#242D21] w-full items-center border-background last:border-none hover:text-primary">
                <router-link
                    @click="$emit('close-mobile-menu')"
                    :to="{ name: '/about' }"
                    class="font-semibold text-[18px] text-[#242D21]"
                >
                    {{ $t("common.about-us") }}
                </router-link>
            </li>
        </template>
    </ul>
    <ul class="border-t-2 border-[#F3F3F3] md:mt-[80px] mt-[40px] pb-4">
        <li
            v-for="link in footerLinks"
            :key="link.title"
            class="my-4 w-full items-center border-background last:border-none hover:text-primary"
        >
            <router-link
                v-if="!link.isOuterLink"
                :to="{ path: link.routeName }"
                class="font-normal text-[18px] text-[#242D21]"
            >
                {{ $t(link.title) }}
            </router-link>
            <a
                v-else
                :href="link.routeName"
                class="font-normal text-[18px] text-[#242D21] link hover:text-primary"
                target="_blank"
            >
                {{ $t(link.title) }}
            </a>
        </li>
        <!--    <li
      class="my-4 w-full items-center border-background last:border-none hover:text-primary"
    >
      <a
        :href="promoLink"
        class="text-[18px]"
        type="application/pdf"
        download
        >{{ $t("footer.promo-text") }}</a
      >
    </li>-->
        <FooterSocialList class="w-full mt-7" />
        <li class="my-4 w-full items-center border-background last:border-none hover:text-primary">
            <span class="text-[14px] text-[#8E8E8E]">Copyright © 2026 — afterschoolvote.com</span>
        </li>
    </ul>
</template>

<script setup>
    import {computed, ref} from 'vue';

    import MenuCategoryList from './MenuCategoryList.vue';
    import FooterSocialList from '@/components/footer/FooterSocialList.vue';

    import footerNav from 'static/footer-nav.ts';
    // import { useI18n } from "vue-i18n";

    // import { PUBLIC_URL } from "@/api/urls";

    defineEmits({
        'close-mobile-menu': null,
        'open-partner-form': null,
    });

    // const { locale } = useI18n();

    const isOpenCategories = ref(false);

    const footerLinks = computed(() => footerNav.slice(2, 4).reduce((acc, block) => {
        acc.push(...block.links);

        return acc;
    }, []));

    const handlecategoriesList = () => {
        isOpenCategories.value = !isOpenCategories.value;
    };

// const promoLink = computed(() => {
//   return `${PUBLIC_URL}pdf/promo/${locale.value}.pdf`;
// });
</script>
